export const EncryptionTypesEnum = {
    None: 'None',
    Tls: 'Tls',
    Ssl: 'Ssl'
};


// WEBPACK FOOTER //
// ./src/services/enums/encryptionTypesEnum.js